import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import IconTooltip from '../../utils/IconTooltip'
import mobileView from '../../utils/mobile.utils'

const useStyles = makeStyles((theme) => ({
  optionRow: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    maxHeight: '40px',
    [theme.breakpoints.down('xs')]: {
        maxHeight: '120px'
    },
    gap: theme.spacing(1),
    marginTop: mobileView ? theme.spacing(5) : theme.spacing(1),
    fontWeight: 'bold',
    marginLeft: '9px',
    color: '#808080'
  },
  optionButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(1),
    textAlign: 'left',
    borderRadius: '4px',
    fontSize: '15px',
    fontWeight: 600,
    marginLeft: '15px',
    color: '#808080',
    border: 'none'
  },
  customRadioContainer: {
    position: 'relative',
    paddingLeft: '35px',
    cursor: 'pointer',
    userSelect: 'none',
    marginBottom: 0
  },
  hiddenRadio: {
    position: 'relative',
    opacity: 0,
    cursor: 'pointer'
  },
  customRadio: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    border: '2px solid #808080',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:after': {
      content: '""',
      position: 'absolute',
      borderRadius: '50%',
      backgroundColor: 'white'
    }
  },
  customRadioChecked: {
    borderColor: '#F67131',
    border: '2px solid #F67131',
    '&:after': {
      backgroundColor: '#F67131',
      width: '12px',
      height: '12px'
    }
  }
}))

const YelSelect = ({ options, isYelSelectionLock, form }) => {
  const { watch, setValue } = form
  const selectedField = watch('yelSelect')
  const classes = useStyles()

  const updateYel = (value) => {
    setValue('yelSelect', value)
  }

  return (
    <div>
      {options.map((option) => (
        <div key={option.value} className={classes.optionRow}>
          <label className={classes.customRadioContainer}>
            <input
              type="radio"
              value={option.value}
              checked={option.value === selectedField}
              onChange={() => updateYel(option.value)}
              disabled={isYelSelectionLock}
              className={classes.hiddenRadio}
            />
            <span
              className={`${classes.customRadio} ${
                option.value === selectedField && classes.customRadioChecked
              }`}
            ></span>
          </label>
          <Button
            onClick={() => updateYel(option.value)}
            disabled={isYelSelectionLock}
            className={classes.optionButton}
          >
            <span>{option.label}</span>
            {option.tooltip && <IconTooltip tooltipShow={option.tooltip} />}
          </Button>
        </div>
      ))}
    </div>
  )
}

export default YelSelect
